import React from 'react'
import styles from './SectionHeader.module.css'

export type SectionHeaderProps = {
  title: string
  titleId?: string
  children?: React.ReactNode
}

const SectionHeader = ({ title, titleId, children }: SectionHeaderProps) => (
  <header className={styles.header}>
    <h2 id={titleId} className={styles.title}>
      {title}
    </h2>
    {children ? <div className={styles.right}>{children}</div> : null}
  </header>
)

export default SectionHeader
